export default __webpack_public_path__ + "static/media/25.da25b525.jpg";